{
  "flaggedStacksPresenter": {
    "title": "Piles signalées",
    "columns": {
      "id": "ID",
      "hangar": "Hangar",
      "date": "Date"
    },
    "buttons": {
      "view": "Voir"
    }
  }
}
